import request from "@/router/axios.js";

import crypto from "@/util/crypto.js";

const decryptTransform = (data) => {
  //解密

  try {
    // 解密
    const backdata = crypto.decrypt(data);
    return backdata;
  } catch (error) {
    // 处理解密过程中的异常
    const backdata = data;
    return backdata;
  }
};

const encryption = (data) => {
  let text = JSON.stringify(data);
  let key = crypto.encrypt(text);
  let formData = new FormData();
  formData.append("data", key);
  return formData;
};

//获取登录信息
export const getLoginInfo = (params) => {
  if (process.env.NODE_ENV === "development") {
    //在开发上调用这个
    return request({
      url: "/api/ygj-integration-chenlh/v1.0/wecom-callback/auth/redirect",
      method: "get",
      params: {
        ...params,
      },
    });
  } else {
    /**
     * 返回示例
     * 
     * {
      "code": 200,
      "success": true,
      "data": {
          "id": "1839151516565078018",
          "tenantId": "590193",
          "userId": "HuangTao",
          "accountId": "59019302002",
          "corpId": "ww937ae0bc982b3055",
          "openId": "",
          "externalUserId": ""
      },
      "msg": "操作成功"
      }
     */
    return request({
      url: "/api/ygj-integration/v1.0/wecom-callback/auth/redirect",
      method: "get",
      params: {
        ...params,
      },
    });
  }
};

export const loginByUsername = (
  tenantId,
  username,
  password,
  type,
  key,
  code,
) =>
  request({
    url: "/api/blade-auth/oauth/token",
    method: "post",
    // 登录不携带 Blade-Auth / Cookie 凭证，避免后端校验报错
    withCredentials: false,
    meta: {
      isToken: false,
    },
    headers: {
      "Tenant-Id": tenantId,
      "Captcha-Key": key,
      "Captcha-Code": code,
    },
    params: {
      tenant_id: tenantId,
      username,
      password,
      grant_type: "captcha",
      scope: "all",
      type,
    },
  });

// 手机号验证码登录
export const loginByPhone = (tenantId, phone, verifyCode, smsToken) =>
  request({
    url: "/api/blade-auth/oauth/token",
    method: "post",
    // 登录不携带 Blade-Auth / Cookie 凭证，避免后端校验报错
    withCredentials: false,
    meta: {
      isToken: false,
    },
    headers: {
      "Tenant-Id": tenantId,
    },
    params: {
      tenant_id: tenantId,
      phone,
      verifyCode,
      grant_type: "phone",
      scope: "all",
      type: "account",
      smsToken,
    },
  });

//获取顶部菜单
export const getTopMenu = (params) => {
  return request({
    url: "/api/blade-system/menu/top-menu",
    method: "get",
    params: {
      ...params,
    },
  });
};

//点击获取菜单
export const getRoutes = (topMenuId) => {
  return request({
    url: "/api/blade-system/menu/routes",
    method: "get",
    params: {
      topMenuId,
    },
  });
};

//获取所有路由 可能没用
export const getallRoutes = (topMenuIds) => {
  return request({
    url: "/api/blade-system/menu/new-routes",
    method: "post",
    data: {
      topMenuIds,
    },
  });
};

//刷新token
export const refreshToken = (refresh_token, tenantId, data) =>
  request({
    url: "/api/blade-auth/oauth/token",
    method: "post",
    headers: {
      "Tenant-Id": tenantId,
    },
    params: {
      ...data,
      tenant_id: tenantId,
      refresh_token,
      grant_type: "refresh_token",
      scope: "all",
    },
  });

export const toLogin = (params) => {
  //secretText :员工ID
  return request({
    url: "/api/blade-auth/oauth/token",
    method: "post",
    params: params,
  });
};

// 获取验证码
export const getCaptcha = (params) => {
  return request({
    url: "/api/blade-auth/oauth/captcha",
    method: "get",
    params,
  });
};

// 获取手机验证码
export const getPhoneCode = (data) => {
  return request({
    url: "/api/ygj-sms/v1.0/sms/get-phone-code",
    method: "post",
    data: data,
  });
};

/**
 * 获取橘子平台托管账号信息
 * 前端将橘子 OAuth 回调的 code 传给后端，接口返回托管账号信息。
 * @param {string} code - 橘子 OAuth 授权码
 */
export const getJuziUserInfo = (code) => {
  return request({
    url: "/api/ygj-integration/v1.0/wecom-rpa/auth/rpa-user-info",
    method: "get",
    params: {
      code,
    },
  });
};

//请求后端获取企微配置

export const getQWsignature = (data) => {
  return request({
    url: "/api/ygj-integration/v1.0/api-account/get-js-signature",
    method: "post",
    data: data,
  });
};

//获取成员所属部门关联的门店ID
export const fetchUserClinic = (data) => {
  let formData = encryption(data);
  return request({
    url: "/api/ygj-integration/v1.0/wecom-user/get-user-clinic",
    method: "post",
    data: formData,
    transformResponse: [decryptTransform],
  });
};

// 新增业务字典
export const addbusiness = (data) => {
  return request({
    url: "/api/blade-system/v1.0/dict-biz/submit-return",
    method: "POST",
    data: data,
  });
};

//编辑业务字典
export const editbusiness = (data) => {
  return request({
    url: "/api/blade-system/v1.0/dict-biz/submit",
    method: "PUT",
    data: data,
  });
};

//删除业务字典
export const removebusiness = (params) => {
  return request({
    url: "/api/blade-system/v1.0/dict-biz/remove",
    method: "DELETE",
    params: params,
  });
};

// 分页获取患者工作单位
export const getWorkUnitApi = (params) => {
  return request({
    url: "/api/blade-system/v1.0/dict-biz/work-unit/page",
    method: "GET",
    params,
  });
};

/**
 * 查看列表的手机号码记录日志
 * {
 *  "patientIds": [],
 *  "place": 0
 * 	 查看列表（1、工作台-今日回访 2、工作台-医生随访 3、工作台-咨询师随访
 *   4、工作台-今日随访 5、营销-回访管理-回访管理 6、营销-回访管理-我的回访 7、营销-咨询管理-网电工作台-我的回访）
 *   8、web端患者查看  9 小程序查看
 *
 * }
 */
export const lookPatientPhone = (data) => {
  return request({
    url: `/api/ygj-patient/v1.0/patient/look-phone`,
    method: "POST",
    data,
  });
};

//获取员工的岗位
export const getEmployeeSett = () => {
  return request({
    url: "/api/ygj-chain/v1.0/employee/get-emp-sett",
    method: "get",
  });
};

// 获取当前企微员工
export const getCurrentQwEmployee = (params) => {
  return request({
    url: "/api/ygj-integration/v1.0/wecom-user/select-user",
    method: "get",
    params,
  });
};

//获取诊所设置
export const getClinicBaseSettingApi = (params) => {
  return request({
    url: "/api/ygj-chain/v2.0/base-setting/list-all",
    method: "get",
    params,
  });
};

// 获取门店详情数据
export const getClinicDetailById = (id) => {
  return request({
    url: `/api/ygj-chain/v1.0/clinic/get/${id}`,
    method: "GET",
  });
};

// 分页查询门店接口
export const getClinicPageByWecomId = (params) => {
  return request({
    url: "/api/ygj-chain/v1.0/clinic/page",
    method: "GET",
    params,
  });
};

// 查询工作诊所范围内区域数据
export const getClinicStructTree = () => {
  return request({
    url: "/api/ygj-chain/struct/select-workplace-tree",
    method: "GET",
  });
};

// 获取门店所在区域
export const getTopArea = (params) => {
  return request({
    url: "/api/ygj-chain/v1.0/clinic/get-struct",
    method: "GET",
    params,
  });
};

// 获取小程序AppId
export const getMiniProgramAppId = (params) => {
  return request({
    url: "/api/ygj-scrm-manage/v1.0/user/get-app-id",
    method: "get",
    params,
  });
};


//获取门店使用的企微信息
export const getWecomInfoByClinic = (params) => {
  return request({
    url: "/api/ygj-integration/v1.0/wecom/get-by-clinic",
    method: "GET",
    params,
  });
};

//查询租户内所有快捷工具页面
export const getShortcutPage = (params) => {
  return request({
    url: "/api/ygj-pdsop/v1.0/app-page/list-shortcut",
    method: "GET",
    params,
  });
};

//获取小程序快捷工具页面推送时关联的详细信息
export const getShortcutPageRelInfo = (params) => {
  return request({
    url: "/api/ygj-pdsop/v1.0/app-page/get-page-rel-info",
    method: "GET",
    params,
  });
};

// 提交小程序页面分享记录
export const submitScrmPageShare = (data) => {
  return request({
    url: "/api/ygj-integration/v1.0/scrm-page-share/submit",
    method: "POST",
    data,
  });
};

// 获取卡券/活动包详情
export const getCouponDetail = (params) => {
  return request({
    url: "/api/ygj-marketing/v1.0/coupon/detail",
    method: "GET",
    params,
  });
};

// 获取商品详情
export const getGoodsDetail = (id) => {
  return request({
    url: `/api/ygj-scrm-manage/v1.0/goods/get/${id}`,
    method: "GET",
  });
};

// 绑定当前用户至企微
export const bindCurrentWecom = (params, accessToken) => {
  const requestConfig = {
    url: "/api/ygj-chain/v1.0/employee/bind-current-wecom",
    method: "POST",
    params: params,
  };
  // 登录后尚未落库 Token 时，用新 token 显式带上鉴权头
  if (accessToken) {
    requestConfig.headers = {
      "Blade-Auth": "bearer " + accessToken,
    };
  }
  return request(requestConfig);
};

// 通过RPA方式绑定企微
export const bindWecomRpa = (data, accessToken) => {
  const requestConfig = {
    url: "/api/ygj-chain/v1.0/employee/bind-wecom-rpa",
    method: "POST",
    data: data,
  };
  // 登录后尚未落库 Token 时，用新 token 显式带上鉴权头
  if (accessToken) {
    requestConfig.headers = {
      "Blade-Auth": "bearer " + accessToken,
    };
  }
  return request(requestConfig);
};


//获取指定企微信息
export const getWecomInfoByCorpId = (params) => {
  return request({
    url: "/api/ygj-integration/v1.0/wecom/get-by-corp-id",
    method: "GET",
    params,
  });
};


//查询租户内所有快捷工具页面
export const getAppPageListShortcut = (params) => {
  return request({
    url: "/api/ygj-pdsop/v1.0/app-page-group/wecom-list",
    method: "GET",
    params,
  });
};
